// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import { Box, TextField, Typography, Button, CircularProgress, useTheme } from "@mui/material";
// import CryptoJS from "crypto-js";

// const AppBankDetails = forwardRef(({ handleFieldChange, initialData }, ref) => {
//   const theme = useTheme();
//   const [formData, setFormData] = useState({
//     bank_account_number: "",
//     bank_name: "",
//     pan_number: "",
//     upi_id: "",
//   });
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (initialData) {
//       setFormData((prev) => ({ ...prev, ...initialData }));
//     }
//   }, [initialData]);

//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     const handleChange = (event) => {
//       const { name, value } = event.target;
    
//       // PAN validation logic
//       if (name === "pan_number") {
//         const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//         if (value && !panRegex.test(value)) {
//           setErrorMessage("Invalid PAN number format.");
//         } else {
//           setErrorMessage("");
//         }
//       }
    
//       setFormData((prev) => ({
//         ...prev,
//         [name]: value || prev[name],
//       }));
//       handleFieldChange("bankDetails", name, value);
//     };
    
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value || prev[name],
//     }));
//     handleFieldChange("bankDetails", name, value);
//   };

//   const handleSubmit = async () => {
//     setLoading(true);
//     try {
//       const isBankDetailsEmpty =
//         !formData.bank_account_number &&
//         !formData.bank_name &&
//         !formData.pan_number &&
//         !formData.upi_id;
//       if (isBankDetailsEmpty) return null;

//       const encryptedapikey = sessionStorage.getItem("encrypted_data");
//       const base64Key = sessionStorage.getItem("base64_Key");
//       let decryptedjwt = "";

//       if (base64Key && encryptedapikey) {
//         const key = CryptoJS.enc.Base64.parse(base64Key);
//         const dataBytes = CryptoJS.enc.Base64.parse(encryptedapikey);
//         const iv = CryptoJS.lib.WordArray.create(dataBytes.words.slice(0, 4));
//         const ciphertext = CryptoJS.lib.WordArray.create(dataBytes.words.slice(4));
//         const decryptedBytes = CryptoJS.AES.decrypt({ ciphertext }, key, { iv });
//         decryptedjwt = CryptoJS.enc.Utf8.stringify(decryptedBytes);
//       }
//       const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-bank-details`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "X-API-Key": decryptedjwt,
//           'Authorization': `Bearer ${accessToken}`
//         },
//         body: JSON.stringify(formData),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         //setSuccessMessage("Bank details saved successfully!");
//         return formData;
//       } else {
//         console.log(data.error || "Error occurred while saving bank details.");
//         return false;
//       }
//     } catch (error) {
//       setErrorMessage("An error occurred while inserting bank details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     handleSubmit,
//   }));

//   return (
//     <Box sx={{ maxWidth: 800, margin: "50px auto", padding: 2 }}>
//       {loading && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <CircularProgress color="primary" />
//         </Box>
//       )}

//       <Typography variant="h5" align="center" sx={{ fontWeight: "bold", color: theme.palette.text.primary }}>
//         Add Employee Bank Details
//       </Typography>
//       <Box
//   component="form"
//   sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
// >
//   {["bank_account_number", "bank_name", "pan_number", "upi_id"].map((field) => (
//     <TextField
//       key={field}
//       name={field}
//       label={field.replace("_", " ").toUpperCase()}
//       value={formData[field]}
//       onChange={handleChange}
//       fullWidth
//       variant="outlined"
//       InputLabelProps={{
//         shrink: true,
//         sx: {
//           color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//           "&.Mui-focused": {
//             color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//           },
//         },
//       }}
//       sx={{
//         "& .MuiOutlinedInput-root": {
//           borderRadius: 2,
//           backgroundColor:
//             theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//           color: theme.palette.text.primary,
    
          
//           "&.Mui-focused": {
//             backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//           },
    
//           "& fieldset": {
//             borderColor:
//               theme.palette.mode === "dark"
//                 ? ""
//                 : "#ccc",
//           },
//           "&:hover fieldset": {
//             borderColor: theme.palette.primary.main,
//           },
//           "&.Mui-focused fieldset": {
//             borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//           },
//         },
//         "& .MuiInputBase-input": {
//           color: theme.palette.text.primary,
//         },
//       }}
//     />
//   ))}
// </Box>


//       {successMessage && (
//         <Typography sx={{ mt: 2, color: "green", textAlign: "center" }}>{successMessage}</Typography>
//       )}
//       {errorMessage && (
//         <Typography sx={{ mt: 2, color: "red", textAlign: "center" }}>{errorMessage}</Typography>
//       )}
//     </Box>
//   );
// });

// export default AppBankDetails;

import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../../../firebaseConfig.js";
import { doc, updateDoc, setDoc } from "firebase/firestore";
import { TextField, Container, Snackbar, Alert, useTheme,Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import CryptoJS from "crypto-js";
import { useParams } from "react-router-dom";
import { tokens } from "../../../../../theme";

const AppBankDetails = forwardRef(({ employeeId: propEmployeeId,   handleFieldChange, initialData }, ref) => {
  const theme = useTheme();
   const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const { employeeId: paramEmployeeId } = useParams();
  const employeeId = propEmployeeId || paramEmployeeId;

  // Unified state for bank details (consistent keys)
  const [bankData, setBankData] = useState({
    UPI_ID: "",
    Bank_Account_Number: "",
    PAN_Number: "",
    Bank_Name: "", 
    Bank_Linked_Date: null,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const isMounted = useRef(true);
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if ((!employeeId && !initialData) || hasFetchedRef.current) return;

    const fetchBankDetails = async () => {
      try {
        setLoading(true);

        let newBankData = {
          UPI_ID: "",
          Bank_Account_Number: "",
          PAN_Number: "",
          Bank_Linked_Date: null,
          Bank_Name: "",
        };


        if (employeeId) {
          const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/bank/${employeeId}`);
          if (!response.ok) throw new Error("Failed to fetch bank details");
          const data = await response.json();

          newBankData = {
            UPI_ID: data.UPI_ID || data.upi_id || "",
            Bank_Account_Number: data.Bank_Account_Number || data.bank_account_number || "",
            PAN_Number: data.PAN_Number || data.pan_number || "",
            Bank_Linked_Date:
              data.Bank_Linked_Date && !isNaN(new Date(data.Bank_Linked_Date).getTime())
                ? new Date(data.Bank_Linked_Date)
                : null,
            Bank_Name: data.Bank_Name || data.bank_name || "",
          };
        } else if (initialData) {
          newBankData = {
            UPI_ID: initialData.UPI_ID || "",
            Bank_Account_Number: initialData.Bank_Account_Number || "",
            PAN_Number: initialData.PAN_Number || "",
            Bank_Linked_Date:
              initialData.Bank_Linked_Date && !isNaN(new Date(initialData.Bank_Linked_Date).getTime())
                ? new Date(initialData.Bank_Linked_Date)
                : null,
            Bank_Name: initialData.Bank_Name || "",
          };
        }

        setBankData((prevData) => {
          const isSame =
            prevData.UPI_ID === newBankData.UPI_ID &&
            prevData.Bank_Account_Number === newBankData.Bank_Account_Number &&
            prevData.PAN_Number === newBankData.PAN_Number &&
            prevData.Bank_Name === newBankData.Bank_Name &&
            ((prevData.Bank_Linked_Date === null && newBankData.Bank_Linked_Date === null) ||
              (prevData.Bank_Linked_Date &&
                newBankData.Bank_Linked_Date &&
                prevData.Bank_Linked_Date.getTime() === newBankData.Bank_Linked_Date.getTime()));

         return isSame ? prevData : newBankData;
        });

        hasFetchedRef.current = true; 
      } catch (error) {
        console.error("Error fetching bank details:", error);
        setSnackbar({ open: true, message: "Failed to load bank details.", severity: "error" });
      } finally {
        if (isMounted.current) setLoading(false);
      }
    };

    fetchBankDetails();
  }, [employeeId, initialData]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBankData((prev) => ({ ...prev, [name]: value }));
    if (handleFieldChange) {
      handleFieldChange("bankDetails", name, value);
    }
  };

  const handleDateChange = (field, value) => {
    setBankData((prev) => ({ ...prev, [field]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    const { UPI_ID, Bank_Account_Number, PAN_Number, Bank_Linked_Date } = bankData;

    if (Bank_Account_Number && Bank_Account_Number.length < 9) {
      newErrors.Bank_Account_Number = "Enter a valid account number.";
    }
    if (UPI_ID && !/^[\w.-]+@[\w.-]+$/.test(UPI_ID)) {
      newErrors.UPI_ID = "Enter a valid UPI ID.";
    }
    if (PAN_Number && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(PAN_Number)) {
      newErrors.PAN_Number = "Enter a valid PAN number.";
    }
   
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async (corporateEmail) => {
    setLoading(true);
    try {
      
      const { Bank_Account_Number, UPI_ID, PAN_Number, Bank_Name,Bank_Linked_Date } = bankData;
      if (!validateForm()) {
      setSnackbar({
          open: true,
          message: "Please fill in all bank details (Account Number, Bank Name, PAN Number, UPI ID).",
          severity: "warning",
        });
        setLoading(false);
        return false;
      }

      const payload = {
        corporate_email_id: corporateEmail,
        bank_account_number: Bank_Account_Number,
        bank_name: Bank_Name,
        pan_number: PAN_Number,
        upi_id: UPI_ID,
        bank_linked_date: Bank_Linked_Date ? Bank_Linked_Date.toISOString() : null,
      };
      const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user?.stsTokenManager?.accessToken;
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-bank-details`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setSnackbar({ open: true, message: "Bank details added successfully!", severity: "success" });
        return true;
      } else {
        setSnackbar({ open: true, message: data.error || "Error adding bank details.", severity: "error" });
        return false;
      }
    } catch (error) {
      setSnackbar({ open: true, message: "Error occurred while adding bank details.", severity: "error" });
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    try {
        const payload = {
          ...bankData,
          Bank_Linked_Date: bankData.Bank_Linked_Date
            ? bankData.Bank_Linked_Date.toISOString()
            : null,
        };
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/update-bank-details/${employeeId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (!response.ok) {
        if (data.message && data.message.toLowerCase().includes("no changes")) {
          setSnackbar({
            open: true,
            message: "No changes detected. Bank details are up to date.",
            severity: "info",
          });
          return true; 
        } else {
          throw new Error(data.message || "Failed to update bank details.");
        }
      } else {
        setSnackbar({
          open: true,
          message: "Bank details updated successfully.",
          severity: "success",
        });
        return true;
      }
    } catch (error) {
      console.error("Error updating bank details:", error);
      setSnackbar({ open: true, message: error.message, severity: "error" });
      return false; 
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref,() => ({
    savedata: async (corporateEmail) => {
      return await handleSave(corporateEmail);
    },

    update: async () => {
        const result = await handleUpdate(); 
        return result; 
    },
      validate: validateForm,
    }),
    [employeeId, handleUpdate, handleSave, validateForm]
  );

   const customInputSx = {
      borderRadius: "8px",
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      }
    };

    const customLabelSx = {
      fontSize: "18px",
      fontWeight: "bold",
      color: colors.grey[100],
      "&.Mui-focused": {
        color: colors.grey[100]
      },
      "&.MuiInputLabel-shrink": {
        color: colors.grey[100]
      }
    };
  return (
    <Container sx={{ mt: 4 }}>
      
      <form>
        {[
          { label: "UPI ID", name: "UPI_ID" },
          { label: "Bank Account Number", name: "Bank_Account_Number" },
          { label: "PAN Number", name: "PAN_Number" },
        ].map((field) => (
          <TextField
            key={field.name}
            label={field.label}
            name={field.name}
            value={bankData[field.name]|| ""}
            onChange={handleChange}
            error={Boolean(errors[field.name])}
            helperText={errors[field.name]|| ""}
            fullWidth
            margin="normal"
            InputLabelProps={{
              shrink: true,
              sx: customLabelSx,
            }}
            InputProps={{
              sx: customInputSx,
            }}
            sx={{ width: "100%" }}
          />
        ))}

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Bank Linked Date"
            value={bankData.Bank_Linked_Date || null}
            onChange={(newValue) => handleDateChange("Bank_Linked_Date", newValue)}
            slotProps={{
              textField: {
                fullWidth: true,
                margin: "normal",
                InputLabelProps: {
                  shrink: true,
                  sx: customLabelSx,
                },
                InputProps: {
                  sx: customInputSx,
                },
                sx: {
                  width: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    minHeight: "56px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#aaa",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#aaa !important",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#aaa !important",
                  },
                  "& .MuiInputBase-input": {
                    padding: "12.5px 14px",
                    fontSize: "1rem",
                    color: theme.palette.text.primary,
                  },
                },
              },
            }}
          />
        </LocalizationProvider>
      </form>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
});

export default AppBankDetails;
